import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import Store from '../../../Store/Store';
import { MET_BASIC_01_Schema } from './M_MET_BASIC_01_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

const toDataResponseFromResult = (res) => {
  const list = res?.Data ?? res?.data ?? (Array.isArray(res) ? res : []);
  return { data: Array.isArray(list) ? list : [] };
};

/** 상세 조회 대표 GetMetBasic01R1 (SP_SUB_BASIC_03_R8) */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.search1,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasic01R1,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 상세 조회 참석자 C GetMetBasic01R2 (SP_SUB_BASIC_03_R4) */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.search2,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasic01R2,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 상세 조회 참석자 I GetMetBasic01R3 (SP_SAC_BASIC_R4) */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.search3,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasic01R3,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 불참 알림 대상 GetMetBasic01R4 (SP_SUB_BASIC_03_R6) */
export const useSearch4 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.search4,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasic01R4,
      params
    );
    return toDataResponseFromResult(res);
  }, successOptions);
};

/** 대표 승인 SaveMetBasic01U1 (SP_SUB_BASIC_03_U5) */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.save1,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.Meeting.saveMetBasic01U1,
      payload
    );
  }, options);
};

/** 참석자 서명 C SaveMetBasic01U2 (SP_SUB_BASIC_03_U4) */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.save2,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.Meeting.saveMetBasic01U2,
      payload
    );
  }, options);
};

/** 참석자 서명 I SaveMetBasic01U3 (SP_SAC_BASIC_U6) */
export const useSave3 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.save3,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.Meeting.saveMetBasic01U3,
      payload
    );
  }, options);
};

/** 참석 여부 C SaveMetBasic01U4 (SP_SUB_BASIC_03_U7) */
export const useSave4 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.save4,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.Meeting.saveMetBasic01U4,
      payload
    );
  }, options);
};

/** 참석 여부 I SaveMetBasic01U5 (SP_SAC_BASIC_U5) */
export const useSave5 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      MET_BASIC_01_Schema.mapper.save5,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.Meeting.saveMetBasic01U5,
      payload
    );
  }, options);
};
